const Form107PICSEN = {
    picsTitle: "Personal Information Collection Statement",
    subtitleList: [
        { text: "Purpose of Collection" },
        { text: "Classes of Transferees" },
        { text: "Access to Personal Data" },
    ],
    symbolStep: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
        { step: "(e)" },
        { step: "(f)" },
        { step: "(g)" },
    ],
    firstStep: [
        {
            text: "The personal data provided by you in this form will be used by the Education Bureau (EDB) for one or more of the following purposes -",
        },
        {
            text: "The provision of personal data required in relation to this form and during the processing of this form is obligatory. In the event that you do not provide those personal data, we may not be able to handle or further process the application.",
        },
        {
            text: "The personal data you provide will be made available to persons working in the EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below -",
        },
        {
            text: "You have the right to request access to and correction of your personal data held by the EDB. Request for access or correction of personal data should be made in writing to the Teacher Registration Team at 2/F, Trade and Industry Tower, 3 Concorde Road, Kowloon.",
        },
    ],
    secondStep: [
        {
            text: "Activities relating to the processing, authentication and counter-checking of the application for registration of teachers, and reviewing the registration of teachers through regular compliance checking;",
        },
        {
            text: "Activities relating to matching of the personal data with the database of other relevant Government bureaux/departments in connection with the activities mentioned in (a) above;",
        },
        {
            text: "Activities relating to matching of the personal data within the database of the EDB for purposes of verifying/updating records of the EDB;",
        },
        {
            text: "Activities relating to training and development including invitation of participation in programmes/activities;",
        },
        {
            text: "Activities relating to the processing and vetting of applications for, and disbursement of, funding/grants/subsidies, and conducting of audits;",
        },
        {
            text: "Activities relating to compilation of statistics, research and Government publications; and ",
        },
        {
            text: "Activities relating to the administration and enforcement of rules and regulations, including but not limited to the Post Secondary Colleges Ordinance (Cap. 320) and its subsidiary legislation.",
        },
    ],
    thirdStep: [
        {
            text: "other Government bureaux, departments and statutory bodies, including but not limited to, Security Bureau, Customs and Excise Department, Department of Justice, Hong Kong Police Force, Immigration Department, Official Receiver’s Office, Registration and Electoral Office and Independent Commission Against Corruption, where necessary, for the purposes mentioned in paragraph 1 above;",
        },
        {
            text: "the personnel of the Post Secondary College in which the form relates for the purposes mentioned in paragraph 1 above; ",
        },
        {
            text: "where you have given your prescribed consent to such disclosure; and",
        },
        {
            text: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        },
    ],
};
export default Form107PICSEN;
